import moment from 'moment';
import { roundTo } from 'round-to';

export const onActionKey = (callback) => (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
        callback(event);
    }
};

export const date = (dateValue, modifyFn) => {
    const newDate = dateValue ? new Date(dateValue) : new Date();
    if (typeof modifyFn === 'function') {
        modifyFn(newDate);
    }
    return newDate;
};

export const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const toLocalDate = (dateToTransform) => {
    let result = null;
    if (dateToTransform) {
        const isoString = moment(dateToTransform).toISOString(true);
        if (isoString) {
            result = isoString.substring(0, 10);
        }
    }
    return result;
};

export const toDateWithoutTime = (dateString) => {
    const newDate = new Date(dateString);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
};

export const isTraceLoggingEnabled = () => process.env.NODE_ENV === 'development' || process.env.REACT_APP_WITH_JS_TRACE_LOGGING === 'true';

export const getComponentDisplayName = (WrappedComponent) => (
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
);

export const extractFirstLetters = (str) => {
    const parts = str.split(/\W+/);
    return parts.map((part) => part.substring(0, 1)).join('');
};

export const formatNumber = (value, fractionDigits) => {
    const parsedValue = parseFloat(value);
    let result = value;
    if (!Number.isNaN(parsedValue)) {
        if (fractionDigits !== null && typeof fractionDigits !== 'undefined') {
            result = parsedValue.toFixed(fractionDigits);
        } else {
            result = String(value);
        }
    }
    return result;
};

export const joinClassNames = (...clsNames) => clsNames.filter(Boolean).join(' ');

export const roundToDecimals = (num, fractionDigits = 2) => roundTo(num, fractionDigits);

export const getCurrentYear = () => new Date().getFullYear();

export const isPriceIncrementModificationForbidden = (auction) => auction.limitBidModification && auction.auctionType === 'SELL';

export const isPriceDecrementModificationForbidden = (auction) => auction.limitBidModification && auction.auctionType === 'BUY';

export const isEqualToEmptyValue = (initialState, newValue) => initialState === null && newValue === '';

export const is8bitChar = (char) => char.charCodeAt(0) > 127;

export const createUserValue = (user, useName) => {
    let nameTooltip;
    if (useName) {
        nameTooltip = user.name ? ` (${user.name})` : '';
    } else {
        nameTooltip = user.userCode ? ` (${user.userCode})` : '';
    }
    return `${user.racf}${nameTooltip}`;
};
